var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 96 960 960"}},[_c('path',{attrs:{"d":"M160 936V456l320-240 320 240v480H560V656H400v280H160Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }